import { getDefaultTaskItemsPerPage } from '@/bundles/Tasks/helpers/defaultPagination';
import { TasksViewTypeEnum } from '@/bundles/Tasks/types';

import mutations from './mutations'

const initialState = {
  tableOptions: {
    itemsPerPage: getDefaultTaskItemsPerPage(),
  },
  viewType: TasksViewTypeEnum.cards,
}
export default {
  namespaced: true,
  state: initialState,
  getters: {},
  actions: {},
  mutations,
}
